import { DateTime } from "luxon";

export const fromMillisSafe = (milliseconds: number): DateTime => {
  const dt = DateTime.fromMillis(milliseconds);
  return dt.isValid ? (dt as DateTime) : DateTime.local();
};
